import { UserStatus } from 'enums/user';

export const isUserDisabled = user => user?.status === UserStatus.Frozen || user?.status === UserStatus.Terminated;
